import MenuButton from './menuButton/menuButton';
import MenuContent from './menuContent/menuContent';

const Menu = () => {
  return (
    <div>
      <MenuButton />
      <MenuContent />
    </div>
  );
};

export default Menu;
